import { ProcessorFolder } from "asset/icons";
import { X } from "lucide-react";
import React, { useState } from "react";
import { GenericBtn } from "./FinanceRequest";
import { ArrowRight } from "iconsax-reactjs";
import FileUploader from "component/finance/FIleUploader";
import { DrawerContent, DrawerTrigger } from "component/ui/Drawer";
import UploadDocModal from "component/form/uploadDocModal";
import { useMutation } from "react-query";
import useUserDetails from "hooks/useUserDetails";
import { handleUploadFileUtils } from "api/fetchers";
import { uploadFinanceBusinessDocuments } from "api/credit-fetchers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const sampleDocuments = {
    "Bank statement":
        "https://trade-vu.lon1.digitaloceanspaces.com/kyc-doc/nigerian-bank-statement.png",
    "Board resolution to open an account":
        "https://trade-vu.lon1.digitaloceanspaces.com/kyc-doc/Board-resolution.png",
};

const Bank = "bankStatement";
const Board = "boardResolution";

const FirstTimeRequest = ({
    setIsFirstTime,
    bankFile,
    setBankFile,
    boardFile,
    setBoardFile,
    canProceed,
    fileKey,
    setFileKey,
    isValid,
}) => {
    const [addDocModal, setAddDocModal] = useState(null);
    const { businessId } = useUserDetails();
    const { mutateAsync: uploadDocumentFunc, isLoading: uploadingDocsLoading } = useMutation({
        mutationFn: ({ selectedFile, name }) => {
            return handleUploadFileUtils({ selectedFile, name });
        },
    });
    const navigate = useNavigate();
    const { mutateAsync: handleUploadDocFunc, isLoading } = useMutation({
        mutationFn: ({ url, name }) => {
            return uploadFinanceBusinessDocuments({ businessId, url, name });
        },
    });

    return (
        <>
            <nav className="flex items-center justify-between w-[96%]  py-3 my-0 md:w-full px-2 md:!px-8 myborder-slixe mx-auto">
                <div className="flex items-center gap-1 pl-0 md:gap-3 md:pl-4">
                    <X
                        size={14}
                        className="rotate-90 cursor-pointer"
                        onClick={() => navigate(-1)}
                    />

                    <h6 className="m-0 text-gray-90 text-base md:text-base font-[450]">
                        Request finance
                    </h6>
                </div>

                <div className="items-center hidden gap-4 pr-0 md:flex md:pr-4">
                    <GenericBtn text={"Continue"} disabled={canProceed} />
                </div>
            </nav>
            <section className="flex flex-col items-center w-11/12 h-full py-4 mx-auto text-center md:w-1/2">
                <ProcessorFolder />
                {!isValid ? (
                    <h3 className="font-[450] text-gray-10 text-lg md:!text-2xl">
                        Submit the required documents to <br /> continue your finance request.
                    </h3>
                ) : (
                    <h3 className="font-[450] text-gray-10 text-lg md:!text-2xl">
                        You’re about to make <br /> your first finance request.{" "}
                    </h3>
                )}
                {isValid && (
                    <p className="mb-8 text-sm font-light md:!text-base text-gray-10">
                        We’ll need a few documents to get you started
                    </p>
                )}
                <main
                    style={{ border: "1px solid #EBEDF9" }}
                    className="flex flex-col gap-6 p-4 mt-4 mb-3 w-[95%] md:w-11/12 rounded-2xl"
                >
                    <FileUploader
                        title="Board resolution to request capital from Tradevu"
                        setFileKey={() => {
                            setFileKey("Board resolution to open an account");
                        }}
                        file={boardFile}
                        onClick={() => setAddDocModal(Board)}
                        setFile={setBoardFile}
                    />
                    <FileUploader
                        title="Bank statement (last 6 months)"
                        setFileKey={() => {
                            setFileKey("Bank statement");
                        }}
                        file={bankFile}
                        onClick={() => setAddDocModal(Bank)}
                        setFile={setBankFile}
                    />
                    <div className="flex items-center justify-end ml-auto">
                        <GenericBtn
                            text={
                                <span className="flex items-center gap-2">
                                    Continue <ArrowRight size={20} />
                                </span>
                            }
                            onClick={() => {
                                setIsFirstTime(false);
                            }}
                            disabled={canProceed}
                        />
                    </div>
                </main>
                <DrawerContent className="z-[999] data-[vaul-drawer-direction=right]:sm:max-w-xl">
                    <aside className="flex flex-col h-full p-3 bg-white rounded-l-md">
                        <div className="h-[90vh]">
                            <div className="flex items-center justify-between">
                                <h3 className="my-0 text-lg font-semibold">Finance Request</h3>
                                <DrawerTrigger asChild className="">
                                    <X size={20} className="cursor-pointer" />
                                </DrawerTrigger>
                            </div>
                            {/* Document Preview */}
                            <div className="p-4">
                                {[sampleDocuments[fileKey]] ? (
                                    <img
                                        src={[sampleDocuments[fileKey]]}
                                        alt={sampleDocuments[fileKey]}
                                        className="w-full h-auto rounded-lg"
                                    />
                                ) : (
                                    <p className="text-center text-gray-500">
                                        No document available
                                    </p>
                                )}
                            </div>
                        </div>
                        <div>
                            <GenericBtn
                                text="Use template 2"
                                disabled={false}
                                onClick={() => {
                                    console.log(false);
                                }}
                            />
                        </div>
                    </aside>
                </DrawerContent>
            </section>
            {addDocModal && (
                <UploadDocModal
                    close={() => setAddDocModal(null)}
                    loading={uploadingDocsLoading || isLoading}
                    uploadFunc={async (selectedFile, name) => {
                        const response = await uploadDocumentFunc({ selectedFile, name });
                      if (response?.statusCode !== 400) {
                            const file = {
                                size: selectedFile?.size,
                                name: name ? name : response?.link,
                                url: response?.link,
                            };
                            console.log({file, response})
                            if (addDocModal === Bank) {
                                const res = await handleUploadDocFunc({
                                    name: Bank,
                                    url: file?.url,
                                });
                                toast.success(res?.message);
                                setBankFile(file);
                            }
                            if (addDocModal === Board) {
                                const res = await handleUploadDocFunc({
                                    name: Board,
                                    url: file?.url,
                                });
                                toast.success(res?.message);
                                setBoardFile(file);
                            }
                            setAddDocModal(null);
                        }
                    }}
                />
            )}
        </>
    );
};

export default FirstTimeRequest;
